<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
// import {docContent} from '@/data/TemplateSuratRujukBalik.js'
import { headerImage } from "@/data/headerImage.js";
import { tandaOperasiImage } from "@/data/tandaOperasiImage.js";
import {
  labelValueFormatter,
  getRuangOperasi,
  getReadableDate,
} from "@/data/helper.js";
export default {
  name: "DocLaporanOperasi",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Laporan Operasi",
      src: "",
      operasi: {},
      content: [],
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_laporan?id_operasi=${this.operasi.id}`
      );
      if (result.data.data.length) {
        this.id_laporan = result.data.data[0].id;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_laporan/${this.id_laporan}`
        );
        this.operasi.laporan = result2.data;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // this.content = docContent;
    this.operasi = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    await this.fetchData();
    //console.log(this.operasi);
    var draft = {
      title: "LAPORAN OPERASI",
      intro: `DETAIL OPERASI`,
      arr1: [
        { label: "Nama Pasien", value: this.operasi.ralan.pasien.nama },
        {
          label: "Tanggal Lahir",
          value: this.operasi.ralan.pasien.formatted_tgl_lahir_umur,
        },
        {
          label: "Jenis Kelamin",
          value: this.operasi.ralan.pasien.jen_kelamin,
        },
        { label: "No. RM", value: this.operasi.ralan.pasien.no_rm },
        { label: "Agama", value: this.operasi.ralan.pasien.agama },
      ],
      arr2: [
        { label: "Tanggal ", value: getReadableDate(this.operasi.tanggal) },
        { label: "Jam Mulai ", value: this.operasi.laporan.time_start },
        { label: "Jam Selesai ", value: this.operasi.laporan.time_end },
        {
          label: "Durasi Operasi ",
          value: this.operasi.laporan.durasi + " Menit",
        },
        {
          label: "Ruang Operasi",
          value: getRuangOperasi(this.operasi.laporan.id_operasi_ruangan),
        },
      ],
      arr3: [
        {
          label: "Dokter Operator",
          value: this.operasi.dokter_operator.nama,
        },
        {
          label: "Dokter Anestesi",
          value: this.operasi.laporan.dokter_anestesi.nama,
        },
        {
          label: "Perawat Instrumen",
          value: this.operasi.laporan.perawat_instrumen.nama,
        },
        {
          label: "Perawat Anestesi",
          value: this.operasi.laporan.perawat_anestesi.nama,
        },
        {
          label: "Perawat Sirkuler",
          value: `${this.operasi.laporan.perawat_sirkuler1.nama}
          ${this.operasi.laporan.perawat_sirkuler2.nama}
          ${this.operasi.laporan.perawat_sirkuler3.nama}
          ${
            this.operasi.laporan.perawat_sirkuler4 &&
            this.operasi.laporan.perawat_sirkuler4.nama
              ? this.operasi.laporan.perawat_sirkuler4.nama
              : ""
          }
          ${
            this.operasi.laporan.perawat_sirkuler5 &&
            this.operasi.laporan.perawat_sirkuler5.nama
              ? this.operasi.laporan.perawat_sirkuler5.nama
              : ""
          }`,
        },
        {
          label: "Nama Operasi",
          value: `${this.operasi.nama_operasi}`,
        },
        {
          label: "Golongan Tindakan",
          value: `${this.operasi.laporan.golongan_tindakan}`,
        },
        {
          label: "Kategori Tindakan",
          value: `${this.operasi.laporan.kategori_tindakan}`,
        },
        {
          label: "Jenis Anestesi",
          value: `Anestesi ${this.operasi.laporan.jenis_anastesi}`,
        },
        {
          label: "Diagnosa Pra Operasi",
          value: this.operasi.laporan.diagnosa_pra_operasi,
        },
        {
          label: "Diagnosa Post Operasi",
          value: this.operasi.laporan.diagnosa_post_operasi,
        },
        {
          label: "Komplikasi",
          value: this.operasi.laporan.komplikasi,
        },
        {
          label: "Jumlah Pendarahan",
          value: this.operasi.laporan.jumlah_pendarahan + " cc",
        },
        {
          label: "Jaringan PA",
          value: this.operasi.laporan.jaringan_pa == "1" ? "Ya" : "Tidak",
        },
        {
          label: "Asal Jaringan",
          value: this.operasi.laporan.asal_jaringan,
        },
        {
          label: "Implant",
          value: this.operasi.laporan.implant,
        },
      ],
    };
    var sign1 = `

    Pasien/Keluarga




    ( __________________________ )`;
    var sign2 = `

    Dokter Operator




    (  ${this.operasi.dokter_operator.nama}  )`;
    let arr1 = labelValueFormatter(draft.arr1, 80);
    let arr2 = labelValueFormatter(draft.arr2, 90);
    let arr3 = labelValueFormatter(draft.arr3, 150);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "title",
      },
      {
        text: "",
        style: "subtitle",
      },
      {
        columns: [[...arr1], [...arr2]],
      },
      {
        style: "subtitleLeft",
        text: draft.intro,
      },
      {
        columns: [[...arr3]],
      },
      {
        columns: [
          {
            style: "sign",
            text: "",
          },
          {
            style: "sign",
            text: "",
          },
          {
            style: "sign",
            text: sign2,
          },
        ],
      },
    ];
  },
};
</script>
